import { render } from "./Expend.vue?vue&type=template&id=4f4e9348&scoped=true"
import script from "./Expend.vue?vue&type=script&lang=js"
export * from "./Expend.vue?vue&type=script&lang=js"

import "./Expend.vue?vue&type=style&index=0&id=4f4e9348&scoped=true&lang=less&rel=stylesheet%2Fless"

import exportComponent from "D:\\phpstudy_pro\\WWW\\guolang\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4e9348"]])

export default __exports__